import * as models from "../../lib/api/models";
import goldVisa1 from "../../images/cards/gold/visa/gold.png";
import goldVisa2 from "../../images/cards/gold/visa/gold@2x.png";
import goldVisa3 from "../../images/cards/gold/visa/gold@3x.png";
import goldMC1 from "../../images/cards/gold/mc/gold.png";
import goldMC2 from "../../images/cards/gold/mc/gold@2x.png";
import goldMC3 from "../../images/cards/gold/mc/gold@3x.png";
import blackVisa1 from "../../images/cards/black/visa/black.png";
import blackVisa2 from "../../images/cards/black/visa/black@2x.png";
import blackVisa3 from "../../images/cards/black/visa/black@3x.png";
import blueVisa1 from "../../images/cards/blue/visa/blue.png";
import blueVisa2 from "../../images/cards/blue/visa/blue@2x.png";
import blueVisa3 from "../../images/cards/blue/visa/blue@3x.png";
import tealVisa1 from "../../images/cards/teal/visa/teal.png";
import tealVisa2 from "../../images/cards/teal/visa/teal@2x.png";
import tealVisa3 from "../../images/cards/teal/visa/teal@3x.png";
import platinumVisa1 from "../../images/cards/platinum/visa/platinum.png";
import platinumVisa2 from "../../images/cards/platinum/visa/platinum@2x.png";
import platinumVisa3 from "../../images/cards/platinum/visa/platinum@3x.png";
import alaskaVisa from "../../images/cards/state/visa/15.png";
import arizonaVisa from "../../images/cards/state/visa/16.png";
import arkansasVisa from "../../images/cards/state/visa/17.png";
import californiaVisa from "../../images/cards/state/visa/18.png";
import coloradoVisa from "../../images/cards/state/visa/19.png";
import connecticutVisa from "../../images/cards/state/visa/20.png";
import delawareVisa from "../../images/cards/state/visa/21.png";
import floridaVisa from "../../images/cards/state/visa/22.png";
import georgiaVisa from "../../images/cards/state/visa/BX.png";
import hawaiiVisa from "../../images/cards/state/visa/24.png";
import idahoVisa from "../../images/cards/state/visa/25.png";
import illinoisVisa from "../../images/cards/state/visa/26.png";
import indianaVisa from "../../images/cards/state/visa/27.png";
import iowaVisa from "../../images/cards/state/visa/28.png";
import kansasVisa from "../../images/cards/state/visa/29.png";
import kentuckyVisa from "../../images/cards/state/visa/30.png";
import louisianaVisa from "../../images/cards/state/visa/31.png";
import maineVisa from "../../images/cards/state/visa/32.png";
import marylandVisa from "../../images/cards/state/visa/33.png";
import massachusettsVisa from "../../images/cards/state/visa/34.png";
import michiganVisa from "../../images/cards/state/visa/35.png";
import minnesotaVisa from "../../images/cards/state/visa/36.png";
import mississippiVisa from "../../images/cards/state/visa/37.png";
import missouriVisa from "../../images/cards/state/visa/38.png";
import montanaVisa from "../../images/cards/state/visa/39.png";
import nebraskaVisa from "../../images/cards/state/visa/40.png";
import nevadaVisa from "../../images/cards/state/visa/41.png";
import newHampshireVisa from "../../images/cards/state/visa/42.png";
import newJerseyVisa from "../../images/cards/state/visa/43.png";
import newMexicoVisa from "../../images/cards/state/visa/44.png";
import newYorkVisa from "../../images/cards/state/visa/45.png";
import northCarolinaVisa from "../../images/cards/state/visa/46.png";
import northDakotaVisa from "../../images/cards/state/visa/47.png";
import ohioVisa from "../../images/cards/state/visa/48.png";
import oklahomaVisa from "../../images/cards/state/visa/49.png";
import oregonVisa from "../../images/cards/state/visa/50.png";
import pennsylvaniaVisa from "../../images/cards/state/visa/51.png";
import rhodeIslandVisa from "../../images/cards/state/visa/52.png";
import southCarolinaVisa from "../../images/cards/state/visa/53.png";
import southDakotaVisa from "../../images/cards/state/visa/54.png";
import tennesseeVisa from "../../images/cards/state/visa/55.png";
import texasVisa from "../../images/cards/state/visa/56.png";
import utahVisa from "../../images/cards/state/visa/57.png";
import vermontVisa from "../../images/cards/state/visa/58.png";
import virginiaVisa from "../../images/cards/state/visa/59.png";
import washingtonVisa from "../../images/cards/state/visa/60.png";
import westVirginiaVisa from "../../images/cards/state/visa/61.png";
import wisconsinVisa from "../../images/cards/state/visa/62.png";
import wyomingVisa from "../../images/cards/state/visa/63.png";
import alaskaMC from "../../images/cards/state/mc/15.png";
import arizonaMC from "../../images/cards/state/mc/16.png";
import arkansasMC from "../../images/cards/state/mc/17.png";
import californiaMC from "../../images/cards/state/mc/18.png";
import coloradoMC from "../../images/cards/state/mc/19.png";
import connecticutMC from "../../images/cards/state/mc/20.png";
import delawareMC from "../../images/cards/state/mc/21.png";
import floridaMC from "../../images/cards/state/mc/22.png";
import georgiaMC from "../../images/cards/state/mc/BX.png";
import hawaiiMC from "../../images/cards/state/mc/24.png";
import idahoMC from "../../images/cards/state/mc/25.png";
import illinoisMC from "../../images/cards/state/mc/26.png";
import indianaMC from "../../images/cards/state/mc/27.png";
import iowaMC from "../../images/cards/state/mc/28.png";
import kansasMC from "../../images/cards/state/mc/29.png";
import kentuckyMC from "../../images/cards/state/mc/30.png";
import louisianaMC from "../../images/cards/state/mc/31.png";
import maineMC from "../../images/cards/state/mc/32.png";
import marylandMC from "../../images/cards/state/mc/33.png";
import massachusettsMC from "../../images/cards/state/mc/34.png";
import michiganMC from "../../images/cards/state/mc/35.png";
import minnesotaMC from "../../images/cards/state/mc/36.png";
import mississippiMC from "../../images/cards/state/mc/37.png";
import missouriMC from "../../images/cards/state/mc/38.png";
import montanaMC from "../../images/cards/state/mc/39.png";
import nebraskaMC from "../../images/cards/state/mc/40.png";
import nevadaMC from "../../images/cards/state/mc/41.png";
import newHampshireMC from "../../images/cards/state/mc/42.png";
import newJerseyMC from "../../images/cards/state/mc/43.png";
import newMexicoMC from "../../images/cards/state/mc/44.png";
import newYorkMC from "../../images/cards/state/mc/45.png";
import northCarolinaMC from "../../images/cards/state/mc/46.png";
import northDakotaMC from "../../images/cards/state/mc/47.png";
import ohioMC from "../../images/cards/state/mc/48.png";
import oklahomaMC from "../../images/cards/state/mc/49.png";
import oregonMC from "../../images/cards/state/mc/50.png";
import pennsylvaniaMC from "../../images/cards/state/mc/51.png";
import rhodeIslandMC from "../../images/cards/state/mc/52.png";
import southCarolinaMC from "../../images/cards/state/mc/53.png";
import southDakotaMC from "../../images/cards/state/mc/54.png";
import tennesseeMC from "../../images/cards/state/mc/55.png";
import texasMC from "../../images/cards/state/mc/56.png";
import utahMC from "../../images/cards/state/mc/57.png";
import vermontMC from "../../images/cards/state/mc/58.png";
import virginiaMC from "../../images/cards/state/mc/59.png";
import washingtonMC from "../../images/cards/state/mc/60.png";
import westVirginiaMC from "../../images/cards/state/mc/61.png";
import wisconsinMC from "../../images/cards/state/mc/62.png";
import wyomingMC from "../../images/cards/state/mc/63.png";
import catVisa from "../../images/cards/stamp/visa/02.png";
import flowerVisa from "../../images/cards/stamp/visa/03.png";
import happyVisa from "../../images/cards/stamp/visa/04.png";
import horseVisa from "../../images/cards/stamp/visa/05.png";
import puppiesVisa from "../../images/cards/stamp/visa/07.png";
import valentineVisa from "../../images/cards/stamp/visa/09.png";
import eagleVisa from "../../images/cards/stamp/visa/12.png";
import dirtVisa from "../../images/cards/stamp/visa/BH.png";
import catPawVisa from "../../images/cards/stamp/visa/BM.png";
import dogVisa from "../../images/cards/stamp/visa/BO.png";
import dogGrassVisa from "../../images/cards/stamp/visa/BQ.png";
import flagsVisa from "../../images/cards/stamp/visa/BR.png";
import penquinsVisa from "../../images/cards/stamp/visa/CI.png";
import catMC from "../../images/cards/stamp/mc/02.png";
import flowerMC from "../../images/cards/stamp/mc/03.png";
import happyMC from "../../images/cards/stamp/mc/04.png";
import horseMC from "../../images/cards/stamp/mc/05.png";
import puppiesMC from "../../images/cards/stamp/mc/07.png";
import valentineMC from "../../images/cards/stamp/mc/09.png";
import eagleMC from "../../images/cards/stamp/mc/12.png";
import dirtMC from "../../images/cards/stamp/mc/BH.png";
import catPawMC from "../../images/cards/stamp/mc/BM.png";
import dogMC from "../../images/cards/stamp/mc/BO.png";
import dogGrassMC from "../../images/cards/stamp/mc/BQ.png";
import flagsMC from "../../images/cards/stamp/mc/BR.png";
import penquinsMC from "../../images/cards/stamp/mc/CI.png";
import capricornVisa from "../../images/cards/astro/visa/81.png";
import aquariusVisa from "../../images/cards/astro/visa/82.png";
import piscesVisa from "../../images/cards/astro/visa/83.png";
import ariesVisa from "../../images/cards/astro/visa/84.png";
import taurusVisa from "../../images/cards/astro/visa/85.png";
import geminiVisa from "../../images/cards/astro/visa/86.png";
import cancerVisa from "../../images/cards/astro/visa/87.png";
import leoVisa from "../../images/cards/astro/visa/88.png";
import virgoVisa from "../../images/cards/astro/visa/89.png";
import libraVisa from "../../images/cards/astro/visa/90.png";
import scorpioVisa from "../../images/cards/astro/visa/91.png";
import sagittariusVisa from "../../images/cards/astro/visa/92.png";
import capricornMC from "../../images/cards/astro/mc/81.png";
import aquariusMC from "../../images/cards/astro/mc/82.png";
import piscesMC from "../../images/cards/astro/mc/83.png";
import ariesMC from "../../images/cards/astro/mc/84.png";
import taurusMC from "../../images/cards/astro/mc/85.png";
import geminiMC from "../../images/cards/astro/mc/86.png";
import cancerMC from "../../images/cards/astro/mc/87.png";
import leoMC from "../../images/cards/astro/mc/88.png";
import virgoMC from "../../images/cards/astro/mc/89.png";
import libraMC from "../../images/cards/astro/mc/90.png";
import scorpioMC from "../../images/cards/astro/mc/91.png";
import sagittariusMC from "../../images/cards/astro/mc/92.png";

export type Card = {
    name: string;
    value: string;
    images: string[];
};

export type CardCategory = {
    value: string;
    id: string;
    textColor: string;
    cardType: string;
    cards: Card[];
};

const strings = {
    gold: "Gold Card",
    state: "State Cards",
    stamp: "STAMP Image Cards",
    astro: "Astrocard",
    capricorn: "Capricorn",
    aquarius: "Aquarius",
    pisces: "Pisces",
    aries: "Aries",
    taurus: "Taurus",
    gemini: "Gemini",
    cancer: "Cancer",
    leo: "Leo",
    virgo: "Virgo",
    libra: "Libra",
    scorpio: "Scorpio",
    sagittarius: "Sagittarius",
    catLooking: "Cat Looking at Fish",
    happyFaceFlower: "Happy Face Flower",
    happyFace: "Happy Face",
    horsebackRider: "Horseback Rider",
    puppies: "Puppies",
    valentineCherubs: "Valentine Cherubs",
    usFlagEagle: "US Flag and Eagle US",
    dirtBiking: "Dirt Biking",
    catWithPaw: "Cat with Paw on Fishbowl",
    dogInCar: "Dog in Car Window",
    dogInGrass: "Dog in Grass Field",
    flags: "Flags",
    penquins: "Penguins",
    alaska: "Alaska",
    arizona: "Arizona",
    arkansas: "Arkansas",
    california: "California",
    colorado: "Colorado",
    connecticut: "Connecticut",
    delaware: "Delaware",
    florida: "Florida",
    georgia: "Georgia",
    hawaii: "Hawaii",
    idaho: "Idaho",
    illinois: "Illinois",
    indiana: "Indiana",
    iowa: "Iowa",
    kansas: "Kansas",
    kentucky: "Kentucky",
    louisiana: "Louisiana",
    maine: "Maine",
    maryland: "Maryland",
    massachusetts: "Massachusetts",
    michigan: "Michigan",
    minnesota: "Minnesota",
    mississippi: "Mississippi",
    missouri: "Missouri",
    montana: "Montana",
    nebraska: "Nebraska",
    nevada: "Nevada",
    newHampshire: "New Hampshire",
    newJersey: "New Jersey",
    newMexico: "New Mexico",
    newYork: "New York",
    northCarolina: "North Carolina",
    northDakota: "North Dakota",
    ohio: "Ohio",
    oklahoma: "Oklahoma",
    oregon: "Oregon",
    pennsylvania: "Pennsylvania",
    rhodeIsland: "Rhode Island",
    southCarolina: "South Carolina",
    southDakota: "South Dakota",
    tennessee: "Tennessee",
    texas: "Texas",
    utah: "Utah",
    vermont: "Vermont",
    virginia: "Virginia",
    washington: "Washington",
    westVirginia: "West Virginia",
    wisconsin: "Wisconsin",
    wyoming: "Wyoming",
    alt: "Card Image For",
    blackCard: "Black Card",
    platinumCard: "Platinum Card",
    blueCard: "Blue Card",
    tealCard: "Teal Card",
};

export const GOLD_CARD_VISA_INDEX = 2;
export const GOLD_CARD_MC_INDEX = 3;

const cardTextColors = {
    gold: "#9f671f",
    silver: "#d0d2d7",
    white: "#fff",
};

const cardCategories: CardCategory[] = [
    {
        value: strings.blackCard,
        id: "black-visa",
        textColor: cardTextColors.white,
        cardType: "BLACK_VISA",
        cards: [
            {
                name: strings.blackCard,
                value: models.CardSelectionOptions.BlackVisa,
                images: [blackVisa1, blackVisa2, blackVisa3],
            },
        ],
    },
    {
        value: strings.blueCard,
        id: "blue-visa",
        textColor: cardTextColors.white,
        cardType: "BLUE_VISA",
        cards: [
            {
                name: strings.blueCard,
                value: models.CardSelectionOptions.BlueVisa,
                images: [blueVisa1, blueVisa2, blueVisa3],
            },
        ],
    },
    {
        value: strings.gold,
        id: "gold-visa",
        textColor: cardTextColors.gold,
        cardType: "GOLD_VISA",
        cards: [
            {
                name: strings.gold,
                value: models.CardSelectionOptions.GoldVisa,
                images: [goldVisa1, goldVisa2, goldVisa3],
            },
        ],
    },
    {
        value: strings.gold,
        id: "gold-mc",
        textColor: cardTextColors.gold,
        cardType: "GOLD_MC",
        cards: [
            {
                name: strings.gold,
                value: models.CardSelectionOptions.GoldMC,
                images: [goldMC1, goldMC2, goldMC3],
            },
        ],
    },
    {
        value: strings.platinumCard,
        id: "platinum-visa",
        textColor: cardTextColors.white,
        cardType: "PLATINUM_VISA",
        cards: [
            {
                name: strings.platinumCard,
                value: models.CardSelectionOptions.Platinum,
                images: [platinumVisa1, platinumVisa2, platinumVisa3],
            },
        ],
    },

    {
        value: strings.tealCard,
        id: "teal-visa",
        textColor: cardTextColors.white,
        cardType: "TEAL_VISA",
        cards: [
            {
                name: strings.tealCard,
                value: models.CardSelectionOptions.TealVisa,
                images: [tealVisa1, tealVisa2, tealVisa3],
            },
        ],
    },
    {
        value: strings.astro,
        id: "astro-visa",
        textColor: cardTextColors.silver,
        cardType: "PHOTOCARD_VISA",
        cards: [
            {name: strings.capricorn, value: "81", images: [capricornVisa]},
            {name: strings.aquarius, value: "82", images: [aquariusVisa]},
            {name: strings.pisces, value: "83", images: [piscesVisa]},
            {name: strings.aries, value: "84", images: [ariesVisa]},
            {name: strings.taurus, value: "85", images: [taurusVisa]},
            {name: strings.gemini, value: "86", images: [geminiVisa]},
            {name: strings.cancer, value: "87", images: [cancerVisa]},
            {name: strings.leo, value: "88", images: [leoVisa]},
            {name: strings.virgo, value: "89", images: [virgoVisa]},
            {name: strings.libra, value: "90", images: [libraVisa]},
            {name: strings.scorpio, value: "91", images: [scorpioVisa]},
            {name: strings.sagittarius, value: "92", images: [sagittariusVisa]},
        ],
    },
    {
        value: strings.astro,
        id: "astro-mc",
        textColor: cardTextColors.silver,
        cardType: "PHOTOCARD_MC",
        cards: [
            {name: strings.capricorn, value: "81", images: [capricornMC]},
            {name: strings.aquarius, value: "82", images: [aquariusMC]},
            {name: strings.pisces, value: "83", images: [piscesMC]},
            {name: strings.aries, value: "84", images: [ariesMC]},
            {name: strings.taurus, value: "85", images: [taurusMC]},
            {name: strings.gemini, value: "86", images: [geminiMC]},
            {name: strings.cancer, value: "87", images: [cancerMC]},
            {name: strings.leo, value: "88", images: [leoMC]},
            {name: strings.virgo, value: "89", images: [virgoMC]},
            {name: strings.libra, value: "90", images: [libraMC]},
            {name: strings.scorpio, value: "91", images: [scorpioMC]},
            {name: strings.sagittarius, value: "92", images: [sagittariusMC]},
        ],
    },
    {
        value: strings.stamp,
        id: "stamp-visa",
        textColor: cardTextColors.silver,
        cardType: "PHOTOCARD_VISA",
        cards: [
            {name: strings.catLooking, value: "02", images: [catVisa]},
            {name: strings.catWithPaw, value: "BM", images: [catPawVisa]},
            {name: strings.dirtBiking, value: "BH", images: [dirtVisa]},
            {name: strings.dogInCar, value: "BO", images: [dogVisa]},
            {name: strings.dogInGrass, value: "BQ", images: [dogGrassVisa]},
            {name: strings.happyFace, value: "04", images: [happyVisa]},
            {name: strings.happyFaceFlower, value: "03", images: [flowerVisa]},
            {name: strings.horsebackRider, value: "05", images: [horseVisa]},
            {name: strings.penquins, value: "CI", images: [penquinsVisa]},
            {name: strings.puppies, value: "07", images: [puppiesVisa]},
            {name: strings.usFlagEagle, value: "12", images: [eagleVisa]},
            {name: strings.flags, value: "BR", images: [flagsVisa]},
            {name: strings.valentineCherubs, value: "09", images: [valentineVisa]},
        ],
    },
    {
        value: strings.stamp,
        id: "stamp-mc",
        textColor: cardTextColors.silver,
        cardType: "PHOTOCARD_MC",
        cards: [
            {name: strings.catLooking, value: "02", images: [catMC]},
            {name: strings.catWithPaw, value: "BM", images: [catPawMC]},
            {name: strings.dirtBiking, value: "BH", images: [dirtMC]},
            {name: strings.dogInCar, value: "BO", images: [dogMC]},
            {name: strings.dogInGrass, value: "BQ", images: [dogGrassMC]},
            {name: strings.happyFace, value: "04", images: [happyMC]},
            {name: strings.happyFaceFlower, value: "03", images: [flowerMC]},
            {name: strings.horsebackRider, value: "05", images: [horseMC]},
            {name: strings.penquins, value: "CI", images: [penquinsMC]},
            {name: strings.puppies, value: "07", images: [puppiesMC]},
            {name: strings.usFlagEagle, value: "12", images: [eagleMC]},
            {name: strings.flags, value: "BR", images: [flagsMC]},
            {name: strings.valentineCherubs, value: "09", images: [valentineMC]},
        ],
    },
    {
        value: strings.state,
        id: "state-visa",
        textColor: cardTextColors.silver,
        cardType: "PHOTOCARD_VISA",
        cards: [
            {name: strings.alaska, value: "15", images: [alaskaVisa]},
            {name: strings.arizona, value: "16", images: [arizonaVisa]},
            {name: strings.arkansas, value: "17", images: [arkansasVisa]},
            {name: strings.california, value: "18", images: [californiaVisa]},
            {name: strings.colorado, value: "19", images: [coloradoVisa]},
            {name: strings.connecticut, value: "20", images: [connecticutVisa]},
            {name: strings.delaware, value: "21", images: [delawareVisa]},
            {name: strings.florida, value: "22", images: [floridaVisa]},
            {name: strings.georgia, value: "BX", images: [georgiaVisa]},
            {name: strings.hawaii, value: "24", images: [hawaiiVisa]},
            {name: strings.idaho, value: "25", images: [idahoVisa]},
            {name: strings.illinois, value: "26", images: [illinoisVisa]},
            {name: strings.indiana, value: "27", images: [indianaVisa]},
            {name: strings.iowa, value: "28", images: [iowaVisa]},
            {name: strings.kansas, value: "29", images: [kansasVisa]},
            {name: strings.kentucky, value: "30", images: [kentuckyVisa]},
            {name: strings.louisiana, value: "31", images: [louisianaVisa]},
            {name: strings.maine, value: "32", images: [maineVisa]},
            {name: strings.maryland, value: "33", images: [marylandVisa]},
            {name: strings.massachusetts, value: "34", images: [massachusettsVisa]},
            {name: strings.michigan, value: "35", images: [michiganVisa]},
            {name: strings.minnesota, value: "36", images: [minnesotaVisa]},
            {name: strings.mississippi, value: "37", images: [mississippiVisa]},
            {name: strings.missouri, value: "38", images: [missouriVisa]},
            {name: strings.montana, value: "39", images: [montanaVisa]},
            {name: strings.nebraska, value: "40", images: [nebraskaVisa]},
            {name: strings.nevada, value: "41", images: [nevadaVisa]},
            {name: strings.newHampshire, value: "42", images: [newHampshireVisa]},
            {name: strings.newJersey, value: "43", images: [newJerseyVisa]},
            {name: strings.newMexico, value: "44", images: [newMexicoVisa]},
            {name: strings.newYork, value: "45", images: [newYorkVisa]},
            {name: strings.northCarolina, value: "46", images: [northCarolinaVisa]},
            {name: strings.northDakota, value: "47", images: [northDakotaVisa]},
            {name: strings.ohio, value: "48", images: [ohioVisa]},
            {name: strings.oklahoma, value: "49", images: [oklahomaVisa]},
            {name: strings.oregon, value: "50", images: [oregonVisa]},
            {name: strings.pennsylvania, value: "51", images: [pennsylvaniaVisa]},
            {name: strings.rhodeIsland, value: "52", images: [rhodeIslandVisa]},
            {name: strings.southCarolina, value: "53", images: [southCarolinaVisa]},
            {name: strings.southDakota, value: "54", images: [southDakotaVisa]},
            {name: strings.tennessee, value: "55", images: [tennesseeVisa]},
            {name: strings.texas, value: "56", images: [texasVisa]},
            {name: strings.utah, value: "57", images: [utahVisa]},
            {name: strings.vermont, value: "58", images: [vermontVisa]},
            {name: strings.virginia, value: "59", images: [virginiaVisa]},
            {name: strings.washington, value: "60", images: [washingtonVisa]},
            {name: strings.westVirginia, value: "61", images: [westVirginiaVisa]},
            {name: strings.wisconsin, value: "62", images: [wisconsinVisa]},
            {name: strings.wyoming, value: "63", images: [wyomingVisa]},
        ],
    },
    {
        value: strings.state,
        id: "state-mc",
        textColor: cardTextColors.silver,
        cardType: "PHOTOCARD_MC",
        cards: [
            {name: strings.alaska, value: "15", images: [alaskaMC]},
            {name: strings.arizona, value: "16", images: [arizonaMC]},
            {name: strings.arkansas, value: "17", images: [arkansasMC]},
            {name: strings.california, value: "18", images: [californiaMC]},
            {name: strings.colorado, value: "19", images: [coloradoMC]},
            {name: strings.connecticut, value: "20", images: [connecticutMC]},
            {name: strings.delaware, value: "21", images: [delawareMC]},
            {name: strings.florida, value: "22", images: [floridaMC]},
            {name: strings.georgia, value: "BX", images: [georgiaMC]},
            {name: strings.hawaii, value: "24", images: [hawaiiMC]},
            {name: strings.idaho, value: "25", images: [idahoMC]},
            {name: strings.illinois, value: "26", images: [illinoisMC]},
            {name: strings.indiana, value: "27", images: [indianaMC]},
            {name: strings.iowa, value: "28", images: [iowaMC]},
            {name: strings.kansas, value: "29", images: [kansasMC]},
            {name: strings.kentucky, value: "30", images: [kentuckyMC]},
            {name: strings.louisiana, value: "31", images: [louisianaMC]},
            {name: strings.maine, value: "32", images: [maineMC]},
            {name: strings.maryland, value: "33", images: [marylandMC]},
            {name: strings.massachusetts, value: "34", images: [massachusettsMC]},
            {name: strings.michigan, value: "35", images: [michiganMC]},
            {name: strings.minnesota, value: "36", images: [minnesotaMC]},
            {name: strings.mississippi, value: "37", images: [mississippiMC]},
            {name: strings.missouri, value: "38", images: [missouriMC]},
            {name: strings.montana, value: "39", images: [montanaMC]},
            {name: strings.nebraska, value: "40", images: [nebraskaMC]},
            {name: strings.nevada, value: "41", images: [nevadaMC]},
            {name: strings.newHampshire, value: "42", images: [newHampshireMC]},
            {name: strings.newJersey, value: "43", images: [newJerseyMC]},
            {name: strings.newMexico, value: "44", images: [newMexicoMC]},
            {name: strings.newYork, value: "45", images: [newYorkMC]},
            {name: strings.northCarolina, value: "46", images: [northCarolinaMC]},
            {name: strings.northDakota, value: "47", images: [northDakotaMC]},
            {name: strings.ohio, value: "48", images: [ohioMC]},
            {name: strings.oklahoma, value: "49", images: [oklahomaMC]},
            {name: strings.oregon, value: "50", images: [oregonMC]},
            {name: strings.pennsylvania, value: "51", images: [pennsylvaniaMC]},
            {name: strings.rhodeIsland, value: "52", images: [rhodeIslandMC]},
            {name: strings.southCarolina, value: "53", images: [southCarolinaMC]},
            {name: strings.southDakota, value: "54", images: [southDakotaMC]},
            {name: strings.tennessee, value: "55", images: [tennesseeMC]},
            {name: strings.texas, value: "56", images: [texasMC]},
            {name: strings.utah, value: "57", images: [utahMC]},
            {name: strings.vermont, value: "58", images: [vermontMC]},
            {name: strings.virginia, value: "59", images: [virginiaMC]},
            {name: strings.washington, value: "60", images: [washingtonMC]},
            {name: strings.westVirginia, value: "61", images: [westVirginiaMC]},
            {name: strings.wisconsin, value: "62", images: [wisconsinMC]},
            {name: strings.wyoming, value: "63", images: [wyomingMC]},
        ],
    },
];

export default cardCategories;
